import React, { useState, useEffect } from 'react';
import {
  collection,
  query,
  orderBy,
  addDoc,
  onSnapshot,
  getDocs,
  doc,
  deleteDoc,
  writeBatch
} from 'firebase/firestore';
import { db } from '../firebase';
import AdminSidebar from '../components/AdminSidebar';
import ChatMessage from '../components/ChatMessage';
import { useParams, useNavigate } from 'react-router-dom';

import './AdminChat.css';

const AdminChat = () => {
  const { driverId } = useParams();
  const navigate = useNavigate();
  const [drivers, setDrivers] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [selectedDriverId, setSelectedDriverId] = useState(driverId || '');
  const [selectedRestaurantId, setSelectedRestaurantId] = useState('');
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (!selectedDriverId && !selectedRestaurantId) {
      navigate('/admin/chat');
    }
  }, [selectedDriverId, selectedRestaurantId, navigate]);

  // جلب قائمة السائقين والمطاعم
  useEffect(() => {
    const fetchData = async () => {
      const driversSnapshot = await getDocs(collection(db, 'drivers'));
      const driversList = driversSnapshot.docs.map(doc => ({
        id: doc.id,
        name: doc.data().name || 'بدون اسم',
      }));
      setDrivers(driversList);

      const restaurantsSnapshot = await getDocs(collection(db, 'restaurants'));
      const restaurantsList = restaurantsSnapshot.docs.map(doc => ({
        id: doc.id,
        name: doc.data().name || 'بدون اسم',
      }));
      setRestaurants(restaurantsList);
    };
    fetchData();
  }, []);

  // تحميل الرسائل
  useEffect(() => {
    const selectedId = selectedDriverId || selectedRestaurantId;
    const chatType = selectedDriverId ? 'driver' : 'restaurant';
    if (!selectedId) return;

    const chatId = `admin_${chatType}_${selectedId}`;
    const q = query(
      collection(db, `chats/${chatId}/messages`),
      orderBy('timestamp', 'asc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      setMessages(snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })));
    });

    return () => unsubscribe();
  }, [selectedDriverId, selectedRestaurantId]);

  // إرسال رسالة
  const sendMessage = async () => {
    const selectedId = selectedDriverId || selectedRestaurantId;
    const chatType = selectedDriverId ? 'driver' : 'restaurant';
    if (!newMessage.trim() || !selectedId) return;

    const chatId = `admin_${chatType}_${selectedId}`;
    await addDoc(collection(db, `chats/${chatId}/messages`), {
      sender: 'admin',
      message: newMessage.trim(),
      timestamp: new Date(),
    });

    setNewMessage('');
  };

  // حذف رسالة واحدة
  const deleteMessage = async (messageId) => {
    const selectedId = selectedDriverId || selectedRestaurantId;
    const chatType = selectedDriverId ? 'driver' : 'restaurant';
    if (!selectedId || !messageId) return;

    const chatId = `admin_${chatType}_${selectedId}`;
    await deleteDoc(doc(db, `chats/${chatId}/messages`, messageId));
  };

  // حذف المحادثة بالكامل
  const deleteEntireConversation = async () => {
    const selectedId = selectedDriverId || selectedRestaurantId;
    const chatType = selectedDriverId ? 'driver' : 'restaurant';
    if (!selectedId) return;

    const confirmDelete = window.confirm("هل أنت متأكد من حذف المحادثة بالكامل؟ سيتم حذفها من الطرفين وهذا الإجراء لا يمكن التراجع عنه.");
    if (!confirmDelete) return;

    try {
      setIsDeleting(true);
      const chatId = `admin_${chatType}_${selectedId}`;
      const batch = writeBatch(db);

      const messagesSnapshot = await getDocs(collection(db, `chats/${chatId}/messages`));
      messagesSnapshot.docs.forEach(doc => {
        batch.delete(doc.ref);
      });

      await batch.commit();

      setMessages([]);
      setIsDeleting(false);
      alert("تم حذف المحادثة بنجاح");
    } catch (error) {
      console.error("خطأ في حذف المحادثة:", error);
      alert("حدث خطأ أثناء حذف المحادثة");
      setIsDeleting(false);
    }
  };

  return (
    <div className="admin-page">
      <AdminSidebar />
      <div className="chat-content">
        <h2>💬 دردشة مع سائق أو مطعم</h2>

        <div className="chat-header">
          <div>
            <label>السائق:</label>
            <select
              value={selectedDriverId}
              onChange={e => {
                setSelectedDriverId(e.target.value);
                setSelectedRestaurantId('');
              }}
            >
              <option value="">-- اختر سائق --</option>
              {drivers.map(driver => (
                <option key={driver.id} value={driver.id}>{driver.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label>المطعم:</label>
            <select
              value={selectedRestaurantId}
              onChange={e => {
                setSelectedRestaurantId(e.target.value);
                setSelectedDriverId('');
              }}
            >
              <option value="">-- اختر مطعم --</option>
              {restaurants.map(rest => (
                <option key={rest.id} value={rest.id}>{rest.name}</option>
              ))}
            </select>
          </div>

          {(selectedDriverId || selectedRestaurantId) && messages.length > 0 && (
            <button
              className="delete-conversation-btn"
              onClick={deleteEntireConversation}
              disabled={isDeleting}
            >
              {isDeleting ? 'جاري الحذف...' : 'حذف المحادثة'}
            </button>
          )}
        {(selectedDriverId || selectedRestaurantId) && (
  <div style={{ marginTop: '10px' }}>
    <strong>🔁 عرض كل محادثات الطرف المحدد:</strong>
    <button
      className="view-monitor-chat-btn"
      onClick={() => {
        if (selectedRestaurantId) {
          navigate(`/admin/monitor/restaurant_${selectedRestaurantId}`);
        } else if (selectedDriverId) {
          navigate(`/admin/monitor/driver_${selectedDriverId}`);
        }
      }}
      style={{
        marginTop: '5px',
        backgroundColor: '#007bff',
        color: 'white',
        padding: '8px 16px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer'
      }}
    >
      عرض المحادثات الآن
    </button>
  </div>
)}

        </div>


        <div className="chat-box">
          {messages.length === 0 ? (
            <div className="empty-chat">
              <p>لا توجد رسائل. ابدأ محادثة جديدة الآن!</p>
            </div>
          ) : (
            messages.map(msg => (
              <ChatMessage key={msg.id} message={msg} onDelete={deleteMessage} />
            ))
          )}
        </div>

        {(selectedDriverId || selectedRestaurantId) && (
          <div className="chat-input">
            <input
              type="text"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder="اكتب رسالتك هنا..."
              onKeyPress={(e) => e.key === 'Enter' && sendMessage()}
            />
            <button onClick={sendMessage}>إرسال</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminChat;